goog.provide('el8.appchart.refpanel.immunizations');

goog.require('el8.appchart.metrics');
goog.require('el8.appchart.permissions');
goog.require('el8.model.base');
goog.require('el8.ptdata.ptImmunizationDeclines');
goog.require('el8.ptdata.ptImmunizations');
goog.require('el8.template.appchart.refpanel.immunizations');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.util.amplitude.immunizationHelpers');


el8.appchart.refpanel.immunizations = (function() {

    function getMenu(item) {
        if (el8Globals.TEASE) { return []; }

        var menu = [];
        if (item.is('PatientImmunization')) {
            menu.push({
                actionText: 'View / Edit Details',
                actionFn: function() {
                    var dlg = el8Globals.FEATURES.IRSubmissions
                      ? el8.appchart.dialog.addEditImmunizationNew
                      : el8.appchart.dialog.addEditImmunization;
                    dlg.show({ptImmunizationId: item.getId()});
                }
            });
        }
        menu.push({
            actionText: 'Export to Note',
            actionFn: function() {
                el8.appchart.mgr.notes.addReference({item: item, sectionName: 'tx'});
                el8.util.amplitude.logImmunizationExportToNote();
            }
        });
        menu.push({
            actionText: 'Remove',
            actionFn: function() {
                var deleteItemFn = function() {
                    if (item.is('PatientImmunization')) {
                        el8.ptdata.ptImmunizations.deleteItem(item);
                    } else {
                        el8.ptdata.ptImmunizationDeclines.deleteItem(item);
                    }
                };
                el8.uiwidget.deleteConfirm('immunization', deleteItemFn);
            }
        });
        return menu;
    }

    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('immunizations');
    function updateRenderedList() {
        var container = $('#immunization-summary');
        var allImm = el8.ptdata.ptImmunizations.all();
        allImm = allImm.concat(el8.ptdata.ptImmunizationDeclines.all());
        allImm = allImm.sort(function(a, b) {
            var aName = (a.getModelClass() === 'PatientImmunization') ? a.getVaccineName() : a.getCdcType();
            var bName = (b.getModelClass() === 'PatientImmunization') ? b.getVaccineName() : b.getCdcType();
            var aDate = (a.getModelClass() === 'PatientImmunization') ? a.getAdministeredDate() : a.getDeclinedDate();
            var bDate = (b.getModelClass() === 'PatientImmunization') ? b.getAdministeredDate() : b.getDeclinedDate();

            var nameCmp = el8.util.string.cmp(aName, bName);
            if (nameCmp !== 0) { return nameCmp; }

            if (aDate.getTime() > bDate.getTime()) { return 1; }
            if (aDate.getTime() < bDate.getTime()) { return -1; }
            return 0;
        });

        container.html(
            el8.template.appchart.refpanel.immunizations.content({
                immunizations: allImm.map(el8.model.toSoyMapFn)
            })
        );
        if (allImm.length) {
            $('.le-empty-entry', '#immunization-history-list').remove();
        }

        reportOnFirstLoad();
    }

    function bindTriggers() {
        $('#immunization-summary').on('click', '.more-actions-trigger',  function() {
            var obj = $(this);
            var itemId = obj.data('id');
            var item;
            if (el8.model.idToModelClass(itemId) === 'PatientImmunization') {
                item = el8.ptdata.ptImmunizations.getById(itemId);
            } else {
                item = el8.ptdata.ptImmunizationDeclines.getById(itemId);
            }
            el8.appchart.refpanel.actionsMenu.display(obj, item, {top: 17, left: 12}, getMenu(item));
            return false;

        }).on('click', '.edit-text-trigger',  function() {
            var itemId = $(this).data('id');
            var dlg = el8Globals.FEATURES.IRSubmissions
              ? el8.appchart.dialog.addEditImmunizationNew
              : el8.appchart.dialog.addEditImmunization;
            dlg.show({ptImmunizationId: itemId});
            return false; // don't open actions menu

        });
    }

    var that = new el8.uiwidget.Component({

        dataRenderers: [
            {
                entitySet: el8.ptdata.ptImmunizations,
                listenFn: updateRenderedList
            },
            {
                entitySet: el8.ptdata.ptImmunizationDeclines,
                listenFn: updateRenderedList
            }
        ]

    });
    bindTriggers();

    // useful when we noNotify the creation of a ptImmunization, if we
    // want to refresh the LHS but not the magic table
    that.triggerRefresh = updateRenderedList;

    return that;

})();
